import React from 'react';
import { Route, Switch } from 'react-router-dom';

import DashboardBots from '../../components/pages/DashboardBots/DashboardBots';
import DashboardFacebook from '../../components/pages/DashboardFacebook/DashboardFacebook';
import DashboardSubjects from '../../components/pages/DashboardSubjects/DashboardSubjects';
import DashboardConversation from '../../components/pages/DashboardConversation/DashboardConversation';

export default ({ match }) => (
	<Switch>
		<Route path={match.path} exact component={DashboardBots} />
		<Route path={`${match.path}/:id/facebook`} component={DashboardFacebook}/>
		<Route exact path={`${match.path}/:id/subjects`} component={DashboardSubjects}/>
		<Route exact path={`${match.path}/:id/settings`} component={DashboardBots}/>
		<Route exact path={`${match.path}/:id/activity`} component={DashboardBots}/>
		<Route exact path={`${match.path}/:id/subjects/:subjectId`} component={DashboardConversation}/>
	</Switch>
);



// WEBPACK FOOTER //
// ./src/redux/config/Routes/bots-router.js